import { Container, Form } from 'react-bootstrap';
import { Button, ValidationForm } from '../../atoms';
import { CustomDropdown, ImageUploader } from '../../molecules';
import styles from './OrganizationAddOrganism.module.css';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';
import { EntityType } from '../../../store/buyerAPI/block/entity-type';
import { DropdownItem } from '../../molecules/CustomDropdown/CustomDropdown';

interface OrganizationAddOrganismProps {
  data: BuyerResponseDto;
  handleOnChange: (data: BuyerResponseDto) => void;
  onSubmit: (data: BuyerResponseDto) => void;
  handleBackgroundOnChange: (imageMeta: ImageMeta) => void;
  handleLogoOnChange: (imageMeta: ImageMeta) => void;
}

const OrganizationAddOrganism = ({
  data,
  handleOnChange,
  onSubmit,
  handleBackgroundOnChange,
  handleLogoOnChange,
}: OrganizationAddOrganismProps) => {
  const types = Object.values(EntityType);
  const dropDownItems: DropdownItem[] = types.map((type) => ({
    eventKey: type,
    label: type,
  }));

  return (
    <Container className={styles.container}>
      <ValidationForm onSubmitCallback={() => onSubmit(data)}>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            value={data?.name ? data?.name : ''}
            onChange={(e) =>
              handleOnChange({
                ...data,
                name: e.target.value,
              })
            }
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Profile Type:</Form.Label>
          <CustomDropdown
            items={dropDownItems}
            initialTitle={
              dropDownItems.find((item) => item.eventKey === data.profileType)
                ?.label ?? 'Choose organization'
            }
            onSelectOption={(e) => {
              handleOnChange({ ...data, profileType: e.eventKey });
            }}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Logo</Form.Label>
          <br />
          <ImageUploader
            imageSrc={data.logo}
            setImage={(e) => {
              handleOnChange({ ...data, logo: e });
            }}
            id="logo-image"
            setImageMeta={(imageMeta) => handleLogoOnChange(imageMeta)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Description</Form.Label>
          <Form.Control
            type="text"
            value={data?.description ? data?.description : ''}
            onChange={(e) =>
              handleOnChange({
                ...data,
                description: e.target.value,
              })
            }
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>
            Website URL (it must start with http:// or https://)
          </Form.Label>
          <Form.Control
            type="text"
            value={data?.url ? data.url : ''}
            onChange={(e) =>
              handleOnChange({
                ...data,
                url: e.target.value,
              })
            }
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Background Image</Form.Label>
          <br />
          <ImageUploader
            imageSrc={data.backgroundImage}
            setImage={(e) => {
              handleOnChange({ ...data, backgroundImage: e });
            }}
            id="background-image"
            setImageMeta={(imageMeta) => handleBackgroundOnChange(imageMeta)}
          />
        </Form.Group>
        <Button variant="dark" type="submit">
          Save
        </Button>
      </ValidationForm>
    </Container>
  );
};

export default OrganizationAddOrganism;
